import type { ICommentProps } from '../Comment';

export const isTitleVisible = ({ title, label, isQuestion, isBuilder, isLegacy, isMobile }: Partial<ICommentProps>) => {
  if (isLegacy && !isMobile) {
    return false;
  }

  const showByContent = !!title || !!label;
  const showByType = (isQuestion && isBuilder) || !isQuestion;

  return showByType && showByContent;
};
